import { render, staticRenderFns } from "./AlertPop.vue?vue&type=template&id=f8d121b8&scoped=true&"
import script from "./AlertPop.vue?vue&type=script&lang=js&"
export * from "./AlertPop.vue?vue&type=script&lang=js&"
import style0 from "./AlertPop.vue?vue&type=style&index=0&id=f8d121b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d121b8",
  null
  
)

component.options.__file = "AlertPop.vue"
export default component.exports